import React from 'react';
import { NavLink } from 'react-router-dom';
import './examSection.scss';

/**
 * Single exam tab in exam board.
 */
function ExamSection(props) {
    const { examData } = props;
    return (
        <NavLink to={'/my-app/exams/' + examData._id}>
            <div className="exam-name-card">
                <div className="exam-img">
                    <img src={examData.jpgImageUrl ? (examData.jpgImageUrl) : '/img/post/thumbnail/post.webp'} alt=""/>
                    <div className="exam-data">
                        <h4>{examData.name}</h4>
                        <span>{examData.completed + '/' + examData.totalQuiz}</span>
                    </div>
                </div>
                <div className="exams-number-attempted">
                    <i className="fa fa-chevron-right"/>
                </div>
            </div>
        </NavLink>
    );
}

export default ExamSection;
